import Paper, { PaperProps } from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Grow from '@mui/material/Grow'
import { memo } from 'react'
import { Theme } from '@mui/material/styles'
import { green } from '@mui/material/colors'
import useEmotionStyledComponent from 'hooks/useEmotionStyledComponent'
import { Banner, BannerType } from '@finanzcheck/teal-components'

const SuccessPaper = (props: PaperProps) => {
  const SuccessPaperStyled = useEmotionStyledComponent<
    typeof Paper,
    PaperProps
  >(
    (theme: Theme) => ({
      root: {
        backgroundColor: green[100],
        color: theme.palette.success.dark,
        padding: theme.spacing(3)
      }
    }),
    Paper,
    props
  )
  return <SuccessPaperStyled {...props} />
}

const ErrorPaper = (props: PaperProps) => {
  const ErrorPaperStyled = useEmotionStyledComponent<typeof Paper>(
    (theme: Theme) => ({
      root: {
        backgroundColor: 'rgba(197, 14, 7, 0.15)',
        color: theme.palette.error.main,
        padding: theme.spacing(3)
      }
    }),
    Paper
  )
  return <ErrorPaperStyled {...props} />
}

export type SaveButtonDialogState = 'none' | 'success' | 'error'

interface SaveButtonDialogProps {
  state: SaveButtonDialogState
}

const SaveButtonDialog = ({ state }: SaveButtonDialogProps) => {
  if (state === 'success') {
    return (
      <Grow in>
        <div>
          <Banner
            type={BannerType.SUCCESS}
            title="Super! Ihre Daten wurden gespeichert."
            desc="Sollten Sie Ihre Dateneingabe heute nicht abschließen, senden wir
              Ihnen einen Link per E-Mail zu, damit Sie Ihre Eingabe später
              vervollständigen können."
          />
        </div>
      </Grow>
    )
  }

  if (state === 'error') {
    return (
      <Grow in>
        <div>
          <ErrorPaper elevation={0}>
            <Typography variant="h6" component="p" gutterBottom color="inherit">
              Es ist leider etwas schiefgelaufen.
            </Typography>
            <Typography variant="body1" color="inherit">
              Bitte versuchen Sie es später erneut.
            </Typography>
          </ErrorPaper>
        </div>
      </Grow>
    )
  }

  return null
}

export default memo(SaveButtonDialog)
